// packages/web/src/api/base.js
//
// Web adapter for @quantbar/api-client.
// Injects localStorageAdapter and the Vite env-var for the API URL.
// All other packages (mobile, desktop) create their own adapter file like this.

import { createApiClient, localStorageAdapter } from '@quantbar/api-client';

const API_BASE = import.meta.env.VITE_API_URL ?? 'http://localhost:4000';

const client = createApiClient(API_BASE, localStorageAdapter);

export const apiRequest = client.apiRequest;
export const handleApiError = client.handleApiError;
export const getAuthToken = client.getAuthToken;
export const clearAuthToken = client.clearAuthToken;

export default apiRequest;
